import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPrinter } from 'react-icons/fi';

const Namuna7Receipt = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const componentRef = useRef();
    const { receiptData } = location.state || {}; // Expecting data passed from the report

    const {
        grampanchayatName = "ग्रामपंचायत इनाम धामणी",
        date = "01/04/2025",
        receiptNo = "-",
        bookNo = "",
        payerName = "संग्राम",
        amount = 100.00,
        amountInWords = "शंभर रुपये",
        reason = "उत्पन्नाचा दाखला प्रत छापाईचे रोख जमा"
    } = receiptData || {};

    useEffect(() => {
        // Auto-trigger print when the component mounts
        const timer = setTimeout(() => {
            window.print();
        }, 500); // Small delay to ensure rendering
        return () => clearTimeout(timer);
    }, []);

    const handlePrint = () => {
        window.print();
    };

    const ReceiptTemplate = () => (
        <div className="border-2 border-black p-4 h-full flex flex-col justify-between text-sm md:text-base">
            <div className="text-center mb-4">
                <h2 className="font-bold text-lg md:text-xl">{grampanchayatName}</h2>
                <h3 className="font-semibold text-md mt-1">नमुना ७</h3>
                <h4 className="font-semibold text-md">सामान्य पावती</h4>
            </div>

            <div className="flex justify-between mb-2">
                <div>दिनांक : <span className="font-medium">{date}</span></div>
                <div>पावती क्रमांक : <span className="font-medium">{receiptNo}</span></div>
            </div>
            <div className="mb-4">
                <div>पुस्तक क्रमांक : <span className="font-medium">{bookNo}</span></div>
            </div>

            <div className="border-t border-b border-black py-4 mb-8 min-h-[100px]">
                <p className="leading-relaxed">
                    <span className="font-bold">{payerName}</span> कडून <span className="font-bold">किरकोळ जमा रकमा</span> च्या खाती रक्कम रुपये <span className="font-bold">{parseFloat(amount).toFixed(2)}</span> मिळाली. {reason}
                </p>
            </div>

            <div className="flex justify-end mt-auto mb-4">
                <div className="text-center w-48">
                    <div className="h-10"></div> {/* Space for signature */}
                    <p className="font-semibold border-t border-gray-400 pt-1">ग्रामपंचायत अधिकारी/क्लार्क</p>
                </div>
            </div>

            <div className="border border-black p-2 text-xs md:text-sm mt-4">
                <p>टीप -१) ही पावती कार्बन पेपरवरुन काढलेल्या दुहेरी प्रतीची असली पाहीजे.</p>
                <p>२) नमुने देण्यात येतील तेव्हा पुस्तकांचे व पावत्यांचे क्रमांक छापण्यात किंवा शिक्याने वटविण्यात आलेले असले पाहिजे.</p>
                <p>३) यथास्थिती ग्रामपंचायत अधिकारी किंवा पंचायतच्या क्लार्क याने त्यास मिळालेल्या रकमेबद्दल पंचायतच्या वतीने पावती दिली पाहीजे.</p>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gray-100 p-4 font-serif">
            {/* No-Print Header */}
            <div className="max-w-[210mm] mx-auto mb-6 flex justify-between items-center print:hidden">
                <button 
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 flex items-center gap-2"
                >
                    <FiArrowLeft /> मागे जा
                </button>
                <button 
                    onClick={handlePrint}
                    className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] flex items-center gap-2"
                >
                    <FiPrinter /> प्रिंट करा
                </button>
            </div>

             {/* Printable Area - A4 Width */}
            <div ref={componentRef} className="max-w-[297mm] mx-auto bg-white p-4 md:p-8 shadow-lg print:shadow-none print:w-full print:max-w-none print:p-0">
                <div className="flex flex-col md:flex-row gap-4 md:gap-8 h-[148mm] print:h-auto">
                    {/* Copy 1 */}
                    <div className="flex-1">
                        <ReceiptTemplate />
                    </div>
                    
                    {/* Divider for print (optional, or just spacing) */}
                    <div className="hidden print:block w-[1px] border-r border-dashed border-gray-300 mx-2"></div>

                    {/* Copy 2 */}
                    <div className="flex-1">
                        <ReceiptTemplate />
                    </div>
                </div>
            </div>
            
            {/* CSS for printing specifically landscape or accommodating two side-by-side */}
            <style type="text/css" media="print">
                {`
                    @page { 
                        size: landscape; 
                        margin: 10mm; 
                    }
                    body { 
                        background: white; 
                    }
                    .print\\:hidden { 
                        display: none !important; 
                    }
                    .print\\:shadow-none { 
                        box-shadow: none !important; 
                    }
                    .print\\:w-full { 
                        width: 100% !important; 
                    }
                `}
            </style>
        </div>
    );
};

export default Namuna7Receipt;
